import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PinFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9999 1.25C6.64573 1.25 3.47217 5.66934 3.47217 10C3.47217 12.0976 4.66084 14.3892 6.01937 16.3532C7.39976 18.3488 9.05511 20.1449 10.175 21.2784C11.1879 22.3035 12.812 22.3035 13.8248 21.2784C14.9448 20.1449 16.6001 18.3488 17.9805 16.3532C19.3391 14.3892 20.5277 12.0976 20.5277 10C20.5277 5.66934 17.3542 1.25 11.9999 1.25ZM12 12C13.2273 12 14.2222 11.0051 14.2222 9.77776C14.2222 8.55046 13.2273 7.55554 12 7.55554C10.7727 7.55554 9.77777 8.55046 9.77777 9.77776C9.77777 11.0051 10.7727 12 12 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PinFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PinFilledIcon;
